/* eslint-disable max-len */
import React from 'react'

import { Aside, Box, Icon, Item, Lista, Logo, Title } from './styles'

import logoNav from 'assets/logo.svg'
import iconCalendar from 'assets/icon-calendar.svg'
import iconSchedule from 'assets/icon-schedule.svg'
import iconTree from 'assets/icon-tree.svg'
import iconList from 'assets/icon-list.svg'

type AsideLoginProps = {
    bgColor: string | undefined
    brandName: string
}

export function AsideLogin({ bgColor, brandName }: AsideLoginProps) {
    return (
        <Aside bgColor={bgColor}>
            <Box>
                <Logo alt="Logo Nav Dasa" src={logoNav} />
                <Title>O {brandName} agora está na plataforma Nav Dasa, onde você pode:</Title>
                <Lista>
                    <Item>
                        <Icon alt="Consultar a cobertura do convênio e valores particulares" src={iconList} /> Consultar a cobertura do
                        convênio e valores particulares
                    </Item>
                    <Item>
                        <Icon alt="Agendar seus exames e vacinas no laboratório, em casa e até no trabalho" src={iconCalendar} />{' '}
                        Agendar seus exames e vacinas no laboratório, em casa e até no trabalho
                    </Item>
                    <Item>
                        <Icon alt="Agendar consultas presenciais, online ou falar com um médico disponível 24h" src={iconSchedule} />{' '}
                        Agendar consultas presenciais, online ou falar com um médico disponível 24h
                    </Item>
                    <Item>
                        <Icon alt="Conferir os resultados de exames e compartilhar com seu médico" src={iconTree} /> Conferir os
                        resultados de exames e compartilhar com seu médico
                    </Item>
                </Lista>
            </Box>
        </Aside>
    )
}
